module.exports = {
	hosts : {
		'live': 'www.partnershipforthefuture.org',
		'test': 'test-partnershipforthefuture.pantheonsite.io',
		'dev': 'dev-partnershipforthefuture.pantheonsite.io',
		'release': 'release-partnershipforthefuture.pantheonsite.io',
		'develop': 'develop-partnershipforthefuture.pantheonsite.io',
		'local': 'partnershipforthefuture.lndo.site',
		'xip': 'partnershipforthefuture.lndo.site.*.*.*.*.xip.io',
		'sync': 'sync-partnershipforthefuture.lndo.site',
	},
	styles: {
		src: 'source/styles',
		dest: 'public/styles'
	},
	scripts: {
		src: 'source/scripts',
		dest: 'public/scripts',
		entries: {
			'carbon-scripts-admin': 'carbon-scripts-admin.js',
			'carbon-scripts-header': 'carbon-scripts-header.js',
			'carbon-scripts-login': 'carbon-scripts-login.js',
			'carbon-scripts-theme': 'carbon-scripts-theme.js'
		}
	},
	fonts: {
		src: 'source/fonts/**/*',
		dest: 'public/fonts'
	},
	images: {
		src: 'source/images',
		dest: 'public/images',
		sprite: 'sprite'
	},
	watch: {
		styles: 'source/styles/**/*.scss',
		scripts: 'source/scripts/**/*.js',
		fonts: 'source/fonts/**/*',
		images: 'source/images/**/*.{png,gif,jpg,jpeg,ico,svg}',
		public: 'public/**/*',
		php: '**/*.php'
	},
	browserSync: {
		// target: 'localhost:80',
		// host: null
	}
};



// WEBPACK FOOTER //
// /app/wp-content/themes/partnershipforthefuture/gulpfile.js/config.js